import React from 'react'
import logo from '../../logo.png'
const NavBrand = () => {
    return (
        <div className="flex items-center">
            <img width={50} src={logo}/>
        </div>
    )
}

export default NavBrand
